export default __webpack_public_path__ + "static/media/2H.cb701b97.svg";